import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { IoDocumentTextSharp, IoFilter } from "react-icons/io5";
import { LuLayoutGrid } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import { fetchEInvoiceEwayLog } from "../../Redux/Einvoice&EwayBillSlice/Einvoice&EwayBill";
import Loader from "../../Components/Loader/Loader";

const EInvoice_Eway_Log = () => {
    const formatDisplayDate = (dateStr) => {
        if (!dateStr || dateStr === "-") return "-";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };

    const dispatch = useDispatch();

    const { EInvoiceEwayLogData, EInvoiceEwayLogLoading } = useSelector((state) => state.EinvoiceEwayBill);

    const [loading, setLoading] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const [filters, setFilters] = useState({
        ClientName: "",
        APIFor: "",
        ResponseStatus: "",
        DateFrom: "",
        DateTo: "",
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                await dispatch(fetchEInvoiceEwayLog());
                setDataLoaded(true);
            } catch (error) {
                console.error("Error fetching E-Invoice/E-Way log data:", error);
                setDataLoaded(true);
            }
        };
        fetchData();
    }, [dispatch]);

    const filterdata = (EInvoiceEwayLogData || [])?.filter((item) => {
        const itemDate = new Date(item.WhaSendDatetime || item.createdAt || item.SendDate);
        const dateTo = filters.DateTo ? new Date(filters.DateTo) : null;
        if (dateTo) {
            dateTo.setHours(23, 59, 59, 999);
        }

        const dateFrom = filters.DateFrom ? new Date(filters.DateFrom) : null;
        if (dateFrom) {
            dateFrom.setHours(0, 0, 0, 0);
        }

        return (
            (!filters.ClientName ||
                item.ClientID?.WhaClientName === filters.ClientName) &&
            (!filters?.ResponseStatus ||
                item?.ResponseStatus?.toString() === filters?.ResponseStatus) &&
            (!filters.APIFor || (filters.APIFor === "Einvoice" ? item.APIFor?.toString().includes("EINV") : filters.APIFor === "Eway" ? item.APIFor?.toString().includes("EWB") : true)) &&
            (!dateFrom || itemDate >= dateFrom) &&
            (!dateTo || itemDate <= dateTo)
        );
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const clearFilters = () => {
        setFilters({
            ClientName: "",
            APIFor: "",
            ResponseStatus: "",
            DateFrom: "",
            DateTo: "",
        });
    };

    console.log("sdfsdrf", filterdata)

    const columns = [
        { field: "id", headerName: "No", flex: 0.2, minWidth: 50 },
        { field: "ClientName", headerName: "Client Name", flex: 0.8, minWidth: 150 },
        { field: "UserName", headerName: "User Name", flex: 0.7, minWidth: 120 },
        { field: "UserDateTime", headerName: "User Date Time", flex: 0.8, minWidth: 150 },
        { field: "APIFor", headerName: "API For", flex: 0.5, minWidth: 80 },
        { field: "APIType", headerName: "API Type", flex: 0.5, minWidth: 80 },
        { field: "TableName", headerName: "Table Name", flex: 0.5, minWidth: 100 },
        { field: "FieldName", headerName: "Field Name", flex: 0.5, minWidth: 100 },
        { field: "UnID", headerName: "UnID", flex: 0.5, minWidth: 80 },
        { field: "SendDate", headerName: "Send Date", flex: 0.8, minWidth: 150 },
        { field: "APIString", headerName: "API String", flex: 2, minWidth: 400, wrap: true },
        {
            field: "sResponse",
            headerName: "Response",
            flex: 2,
            minWidth: 450,
            renderCell: ({ row }) => {
                const val = row.sResponse;
                const isSuccess = row.ResponseStatus === "True";
                if (!val || val === "-") return <span className="text-gray-400 italic">No Response</span>;
                try {
                    const parsed = typeof val === "string" ? JSON.parse(val) : val;
                    return (
                        <div className="w-full h-full py-2 flex flex-col justify-center">
                            <div className={`${isSuccess ? 'bg-emerald-50 border-emerald-200' : 'bg-rose-50 border-rose-200'} border rounded-lg p-2 overflow-y-auto max-h-[120px] shadow-sm transition-all hover:shadow-md`}>
                                <pre className={`text-[11px] leading-relaxed font-mono ${isSuccess ? 'text-emerald-800' : 'text-rose-800'} whitespace-pre-wrap break-all text-left`}>
                                    {JSON.stringify(parsed, null, 2)}
                                </pre>
                            </div>
                        </div>
                    );
                } catch (e) {
                    return <div className={`text-[11px] font-medium ${isSuccess ? 'text-emerald-600' : 'text-rose-600'} italic p-2 rounded-lg bg-gray-50 text-left`}>{String(val)}</div>;
                }
            },
        },
        {
            field: "Data",
            headerName: "Data",
            flex: 1.5,
            minWidth: 300,
            renderCell: ({ row }) => {
                const val = row.Data;
                if (!val || val === "-") return <span className="text-gray-400 italic">-</span>;
                try {
                    const parsed = typeof val === "string" ? JSON.parse(val) : val;
                    return (
                        <div className="w-full h-full py-2 flex flex-col justify-center">
                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 overflow-y-auto max-h-[100px]">
                                <pre className="text-[10px] leading-tight font-mono text-blue-800 whitespace-pre-wrap break-all text-left">
                                    {JSON.stringify(parsed, null, 2)}
                                </pre>
                            </div>
                        </div>
                    );
                } catch (e) {
                    return <div className="text-[10px] text-blue-700">{String(val)}</div>;
                }
            },
        },
        { field: "ResponseStatus", headerName: "Status", flex: 0.3, minWidth: 70 },
        {
            field: "ErrorDetails",
            headerName: "Error Details",
            flex: 1.5,
            minWidth: 300,
            renderCell: ({ row }) => {
                const val = row.ErrorDetails;
                if (!val || val === "-") return <span className="text-gray-400 italic">-</span>;
                try {
                    const parsed = typeof val === "string" ? JSON.parse(val) : val;
                    return (
                        <div className="w-full h-full py-2 flex flex-col justify-center">
                            <div className="bg-rose-50 border border-rose-200 rounded-lg p-2 overflow-y-auto max-h-[100px]">
                                <pre className="text-[10px] leading-tight font-mono text-rose-800 whitespace-pre-wrap break-all text-left">
                                    {JSON.stringify(parsed, null, 2)}
                                </pre>
                            </div>
                        </div>
                    );
                } catch (e) {
                    return <div className="text-[10px] text-rose-700">{String(val)}</div>;
                }
            },
        },
        { field: "ErrorCodes", headerName: "Error Codes", flex: 0.5, minWidth: 100 },
        {
            field: "Message",
            headerName: "Message",
            flex: 2,
            minWidth: 400,
            renderCell: ({ row }) => (
                <div className={`py-2 text-[11px] leading-snug whitespace-pre-wrap break-all ${row.ResponseStatus === "True" ? "text-slate-700" : "text-rose-700"} font-medium text-left`}>
                    {row.Message || "-"}
                </div>
            )
        },
        { field: "Sek", headerName: "Sek", flex: 1.2, minWidth: 250, wrap: true },
        { field: "AppKey", headerName: "App Key", flex: 1.2, minWidth: 250, wrap: true },
    ];

    const rows =
        filterdata?.map((el, index) => ({
            id: index + 1,
            MainId: el._id,
            ClientName: el?.ClientID?.WhaClientName || el?.clientname || "-",
            UserName: el?.UserName || "-",
            UserDateTime: el?.UserDateTime || "-",
            APIFor: el?.APIFor || "-",
            APIType: el?.APIType || "-",
            TableName: el?.TableName || "-",
            FieldName: el?.FieldName || "-",
            UnID: el?.UnID || "-",
            SendDate: formatDisplayDate(el?.SendDate || el?.WhaSendDatetime || el?.createdAt),
            APIString: typeof el?.APIString === "object" ? JSON.stringify(el?.APIString) : (el?.APIString || "-"),
            ResponseStatus: el?.ResponseStatus ? "True" : "False",
            sResponse: typeof el?.sResponse === "object" ? JSON.stringify(el?.sResponse) : (el?.sResponse || "-"),
            Data: typeof el?.Data === "object" ? JSON.stringify(el?.Data) : (el?.Data || "-"),
            ErrorDetails: typeof el?.ErrorDetails === "object" ? JSON.stringify(el?.ErrorDetails) : (el?.ErrorDetails || "-"),
            Exception: typeof el?.Exception === "object" ? JSON.stringify(el?.Exception) : (el?.Exception || "-"),
            ErrorCodes: typeof el?.ErrorCodes === "object" ? JSON.stringify(el?.ErrorCodes) : (el?.ErrorCodes || "-"),
            Message: typeof el?.Message === "object" ? JSON.stringify(el?.Message) : (el?.Message || "-"),
            Sek: typeof el?.Sek === "object" ? JSON.stringify(el?.Sek) : (el?.Sek || "-"),
            AppKey: typeof el?.AppKey === "object" ? JSON.stringify(el?.AppKey) : (el?.AppKey || "-"),
        })) || [];

    const exportToExcel = () => {
        const sourceData = (filterdata && filterdata.length > 0) ? filterdata : (EInvoiceEwayLogData || []);
        if (!sourceData || sourceData.length === 0) {
            alert("No log data available to export!");
            return;
        }

        setLoading(true);

        const dataToExport = sourceData.map((item, index) => ({
            "No": index + 1,
            "Client Name": item.ClientID?.WhaClientName || item.clientname || (typeof item.ClientID === "string" ? item.ClientID : "-"),
            "API For": item.APIFor || "-",
            "API Type": item.APIType || "-",
            "Table Name": item.TableName || "-",
            "Field Name": item.FieldName || "-",
            "UnID": item.UnID || "-",
            "Send Date": formatDisplayDate(item.SendDate || item.WhaSendDatetime || item.createdAt),
            "API String": typeof item.APIString === "object" ? JSON.stringify(item.APIString) : (item.APIString || "-"),
            "Response Status": item.ResponseStatus ? "True" : "False",
            Response: typeof item.sResponse === "object" ? JSON.stringify(item.sResponse) : (item.sResponse || item.Response || "-"),
            Data: typeof item.Data === "object" ? JSON.stringify(item.Data) : (item.Data || "-"),
            "Error Details": typeof item.ErrorDetails === "object" ? JSON.stringify(item.ErrorDetails) : (item.ErrorDetails || "-"),
            Exception: typeof item.Exception === "object" ? JSON.stringify(item.Exception) : (item.Exception || "-"),
            "Error Codes": typeof item.ErrorCodes === "object" ? JSON.stringify(item.ErrorCodes) : (item.ErrorCodes || "-"),
            Message: typeof item.Message === "object" ? JSON.stringify(item.Message) : (item.Message || "-"),
            Sek: typeof item.Sek === "object" ? JSON.stringify(item.Sek) : (item.Sek || "-"),
            "App Key": typeof item.AppKey === "object" ? JSON.stringify(item.AppKey) : (item.AppKey || "-")
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);

        // Auto column widths
        worksheet["!cols"] = Object.keys(dataToExport[0] || {}).map((key) => {
            const maxLen = Math.max(
                key.length,
                ...dataToExport.slice(0, 50).map((r) => String(r[key] || "").length)
            );
            return { wch: Math.min(Math.max(maxLen + 3, 10), 50) };
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "EInvoice_Eway_Logs");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const data = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });

        saveAs(data, "EInvoice_EWay_Log_Report.xlsx");

        setTimeout(() => {
            setLoading(false);
        }, 500);
    };

    if (EInvoiceEwayLogLoading || !dataLoaded) {
        return <Loader />;
    }

    return (
        <div className="p-3">
            <div className="title flex flex-col lg:flex-row lg:justify-between lg:items-center gap-3">
                <h3 className="text-xl font-bold main_title_page text-white px-5 py-2 rounded w-full lg:w-auto text-center lg:text-left">
                    E-Invoice & E-Way Log Report
                </h3>

                <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full lg:w-auto">
                    <button
                        onClick={exportToExcel}
                        disabled={loading}
                        className="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700 disabled:opacity-50 flex items-center justify-center text-sm font-semibold"
                    >
                        <IoDocumentTextSharp size={18} className="me-1" />
                        {loading ? "Exporting..." : "Export to Excel"}
                    </button>

                    <button
                        onClick={() => setIsDrawerOpen(true)}
                        className="bg-gray-600 text-white px-3 py-2 rounded hover:bg-gray-700 flex items-center justify-center text-sm font-semibold"
                    >
                        <IoFilter size={18} className="me-1" />
                        Open Filters
                    </button>

                    <button
                        onClick={clearFilters}
                        className="bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 flex items-center justify-center text-sm font-semibold"
                    >
                        <LuLayoutGrid size={18} className="me-1" />
                        Show All
                    </button>
                </div>
            </div>

            <div className="rounded-lg overflow-hidden mt-5">
                {filterdata && filterdata.length > 0 ? (
                    <WpDynamicTable columns={columns} rows={rows} height="700px" rowsPerPage={10} />
                ) : (
                    <div className="text-center py-20 bg-gray-50">
                        <p className="text-gray-500 text-lg">No log data found.</p>
                    </div>
                )}
            </div>

            {isDrawerOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-2">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                        <div className="p-6 flex flex-col">
                            <div className="flex items-center justify-between mb-6 border-b pb-4">
                                <h2 className="text-2xl font-bold text-gray-800">
                                    Filter Logs
                                </h2>
                                <button
                                    onClick={() => setIsDrawerOpen(false)}
                                    className="text-gray-400 hover:text-gray-600 transition-colors text-3xl leading-none"
                                >
                                    &times;
                                </button>
                            </div>

                            <form className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div className="col-span-1 md:col-span-2">
                                    <label className="text-sm font-bold text-gray-700 mb-1 block">Client Name</label>
                                    <select
                                        name="ClientName"
                                        value={filters.ClientName}
                                        onChange={handleFilterChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                    >
                                        <option value="">All Clients</option>
                                        {[...new Set(EInvoiceEwayLogData?.map(el => el?.ClientID?.WhaClientName))].filter(Boolean).map(client => (
                                            <option key={client} value={client}>{client}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="text-sm font-bold text-gray-700 mb-1 block">Log Type</label>
                                    <select
                                        name="APIFor"
                                        value={filters.APIFor}
                                        onChange={handleFilterChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                    >
                                        <option value="">All Types</option>
                                        <option value="Einvoice">E-Invoice</option>
                                        <option value="Eway">E-Way</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="text-sm font-bold text-gray-700 mb-1 block">Status (True/False)</label>
                                    <select
                                        name="ResponseStatus"
                                        value={filters.ResponseStatus}
                                        onChange={handleFilterChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                    >
                                        <option value="">All</option>
                                        <option value="true">True</option>
                                        <option value="false">False</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="text-sm font-bold text-gray-700 mb-1 block">From Date</label>
                                    <input
                                        type="date"
                                        name="DateFrom"
                                        value={filters.DateFrom}
                                        onChange={handleFilterChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="text-sm font-bold text-gray-700 mb-1 block">To Date</label>
                                    <input
                                        type="date"
                                        name="DateTo"
                                        value={filters.DateTo}
                                        onChange={handleFilterChange}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
                                    />
                                </div>
                            </form>

                            <div className="flex justify-end gap-3 mt-8 border-t pt-5">
                                <button
                                    type="button"
                                    onClick={clearFilters}
                                    className="px-6 py-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-600 font-semibold transition-colors"
                                >
                                    Clear Filters
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EInvoice_Eway_Log;